import { useEffect, useState } from 'react';
import { useSessionStorage } from '../hooks/useSessionStorage';

export const useTimers = (email) => {
  const [resendTimer, setResendTimer] = useState(0);
  const [longResendTimer, setLongResendTimer] = useState(0);

  const storage = useSessionStorage(email);

  useEffect(() => {
    if (storage) {
      const savedLongResendTimer = storage.get('longResendTimer');
      if (savedLongResendTimer && savedLongResendTimer.endTime) {
        const nowSec = Math.floor(Date.now() / 1000);
        const remaining = Math.max(0, savedLongResendTimer.endTime - nowSec);
        if (remaining > 0) {
          setLongResendTimer(prev => {
            if (prev !== savedLongResendTimer.endTime) {
              return savedLongResendTimer.endTime;
            }
            return prev;
          });
        } else {
          setLongResendTimer(prev => {
            if (prev > 0) return 0;
            return prev;
          });
          storage.remove('longResendTimer');
        }
      }
    }
  }, [storage]);

  useEffect(() => {
    if (resendTimer <= 0) return;

    const timer = setTimeout(() => {
      setResendTimer(prev => {
        if (prev <= 1) return 0;
        return prev - 1;
      });
    }, 1000);

    return () => clearTimeout(timer);
  }, [resendTimer]);

  useEffect(() => {
    if (longResendTimer <= 0) return;

    const nowSec = Math.floor(Date.now() / 1000);
    if (longResendTimer <= nowSec) {
      setLongResendTimer(0);
      if (storage) {
        storage.remove('longResendTimer');
      }
      return;
    }

    const timeUntilEnd = (longResendTimer - nowSec) * 1000;
    const timer = setTimeout(() => {
      setLongResendTimer(0);
      if (storage) {
        storage.remove('longResendTimer');
      }
    }, timeUntilEnd);

    return () => clearTimeout(timer);
  }, [longResendTimer, storage]);

  return {
    resendTimer,
    setResendTimer,
    longResendTimer,
    setLongResendTimer,
  };
};
